import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import selectHelper from '../../../Helpers/selectHelper';
import FeeTypesEnum from '../../../Enums/FeeTypesEnum';
import OutsourcedFeeService from '../../../Services/OutsourcedFeeService';
import OutsourcedFeeItem from '../../../Domain/OutsourcedFeeItem';
import OfficeService from '../../../Services/OfficeService';
import ErrorMessage from '../../../Elements/ErrorMessage';

class EditOutsourcedFeeWindowDescription extends React.Component {
  static titleForCreate = 'Create Outsourced Fee';
  static titleForEdit = (editedItem) =>
    editedItem && editedItem.OutsourcedFeeId ? 'Edit Outsourced Fee' : 'Clone Outsourced Fee';

  static itemType = OutsourcedFeeItem;

  static serviceFunction = (editedItem) => OutsourcedFeeService.Upsert(editedItem);

  static errorHandler = (error) => ErrorMessage.SetWarning(error);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'OutsourcingOfficeId',
          label: 'Work Done By',
          className: 'col-4',
          type: InputTypesEnum.OfficeSelect,
          showFilterAt: 9999,
          validityChecker: ValidityHelper.forRequiredSelectField,
          onFieldChange: EditOutsourcedFeeWindowDescription.onOutsourcingOfficeChange,
        },
        {
          fieldName: 'FieldworkOfficeId',
          label: 'Bill To Office',
          className: 'col-4',
          type: InputTypesEnum.OfficeSelect,
          showFilterAt: 9999,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'FeeType',
          label: 'Fee Type',
          className: 'col-4',
          type: InputTypesEnum.Select,
          selectvalues: EditOutsourcedFeeWindowDescription.getSelectValuesForFeeType,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'FeeAmount',
          label: (item) => `Fee Amount (${item.CurrencyCode})`,
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'StartDate',
          label: 'Start Date',
          className: 'col-4',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'EndDate',
          label: 'End Date',
          className: 'col-4',
          type: InputTypesEnum.DateWithIndefinite,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ClientId',
          label: 'Client',
          className: 'col-12',
          type: InputTypesEnum.ClientSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ThirdPartySource',
          label: 'Third Party Source',
          className: 'col-12',
          type: InputTypesEnum.ThirdPartySourceSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => !item.ClientId,
        },
        {
          fieldName: 'SurveyId',
          label: 'Survey',
          className: 'col-12',
          type: InputTypesEnum.SurveySelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => !item.ThirdPartySource || !item.ClientId,
          hide: (item) => item.ThirdPartySource && item.ThirdPartySource !== 'Apollo',
        },
        {
          fieldName: 'WaveId',
          label: 'Wave',
          className: 'col-12',
          type: InputTypesEnum.WaveSelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => !item.ThirdPartySource || !item.ClientId,
          hide: (item) => item.ThirdPartySource && item.ThirdPartySource !== 'Apollo',
        },
        {
          fieldName: 'TpSurveyId',
          label: 'TP Survey',
          className: 'col-12',
          type: InputTypesEnum.TpSurveySelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => !item.ClientId,
          hide: (item) => !item.ThirdPartySource || item.ThirdPartySource === 'Apollo',
        },
        {
          fieldName: 'TpWaveId',
          label: 'TP Wave',
          className: 'col-12',
          type: InputTypesEnum.TpWaveSelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => !item.ClientId,
          hide: (item) => !item.ThirdPartySource || item.ThirdPartySource === 'Apollo',
        },
      ],
    },
  ];

  static async onOutsourcingOfficeChange(editedItem) {
    if (editedItem.OutsourcingOfficeId) {
      const currency = await OfficeService.GetOfficeBillingCurrency(editedItem.OutsourcingOfficeId);
      editedItem.CurrencyCode = currency.currencyCode;
    } else {
      editedItem.CurrencyCode = null;
    }
  }

  static getSelectValuesForFeeType() {
    return selectHelper.generateSelectValues([
      '',
      FeeTypesEnum.RM,
      FeeTypesEnum.DQ,
      FeeTypesEnum.KAM,
      FeeTypesEnum.BD,
      FeeTypesEnum.BI,
      FeeTypesEnum.IT,
      FeeTypesEnum.HR,
      FeeTypesEnum.Marketing,
      FeeTypesEnum.Finance,
    ]);
  }
}

export default EditOutsourcedFeeWindowDescription;
